/**
 * DashboardHeader - Breadcrumb navigation for LiveDashboardV2
 */
import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb } from 'react-bootstrap'
import styles from '../../LabsV2.module.css'

const DashboardHeader = ({ courseId, examId, examTitle, courseName }) => {
  return (
    <div className={styles.dashboardHeader}>
      <Breadcrumb className={styles.dashboardBreadcrumb}>
        <Breadcrumb.Item
          linkAs={Link}
          linkProps={{ to: `/courseware/course/${courseId}` }}
        >
          {courseName || 'Course'}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          linkAs={Link}
          linkProps={{ to: `/courseware/course/${courseId}/content/labs` }}
        >
          Labs
        </Breadcrumb.Item>
        <Breadcrumb.Item
          linkAs={Link}
          linkProps={{ to: `/courseware/course/${courseId}/content/labs/proctor` }}
        >
          Proctor
        </Breadcrumb.Item>
        <Breadcrumb.Item
          linkAs={Link}
          linkProps={{ to: `/courseware/course/${courseId}/content/labs/${examId}` }}
        >
          {examTitle || 'Loading...'}
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  )
}

export default DashboardHeader
